import { selectScheduleConstants } from "../../actionTypes";

const initialState = {
 selectedScheduleData: [],
};

export function selectScheduleReducer(state: any = initialState, action: any) {
  switch (action.type) {
   
    case selectScheduleConstants.GET_SELECT_SCHEDULE_DATA:
      return {
        ...state,
        selectedScheduleData: action.payload,
      };
  
    default:
      return state;
  }
}
